import React, { useCallback, useEffect, useState } from 'react';
import { Camera } from 'expo-camera';

import { IdCardContent, PrimaryLoader } from '../../components';

export function IdCard() {
  const [loadToken, setLoadToken] = useState(true);

  const handlePermissions = useCallback(async () => {
    await Camera.requestPermissionsAsync();
  }, []);

  useEffect(() => {
    handlePermissions();
  }, [handlePermissions]);

  useEffect(() => {
    (async () => {
      try {
        setLoadToken(false);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  if (loadToken) {
    return <PrimaryLoader />;
  }

  return <IdCardContent />;
}
